module.exports = {
  menu: {
    home: "トップページ",
    product: "製品とサービス",
    aboutus: "取引先の会社（一部）",
    contactus: "連絡先",
    login: "Partnerships"
  },
  select: {
    title: "選択言語",
    lang: [
      {
        key: "zh-CN",
        name: "簡体中国语"
      },
      {
        key: "zh-TW",
        name: "繁体中国语"
      },
      {
        key: "en",
        name: "英語"
      },
      {
        key: "ja",
        name: "日本语"
      },
      {
        key: "ko",
        name: "韩国语"
      }
    ]
  },
  brandIntro: {
    title: "上海富恵ネットワーク株式会社",
    slogan: "Slogan：デジタルテクノロジーで、グローバルビジネスの持続的成長を支援",
    intro: {
      title: "ブランド概要",
      paragraphs: [
        "Link2shops（上海富恵ネットワーク株式会社）は、国内外の企業向けデジタル成長サービス分野に特化した、売上創出・会員増加などの成果を最重視するAIビジネス成長ソリューションプロバイダーです。最新の大規模言語モデルを深く融合し、AIをデジタルマーケティング、会員特典サービス、全域集客と密接に連携。システム開発、サプライチェーン協業、流通・販促、精緻な運営を一体化したエンドツーエンドのデジタルソリューションを提供します。自社開発のAI営業システムにより、新規顧客獲得の難しさ、低いコンバージョン率、人員効率の不足といった核心的課題に直接アプローチし、新規獲得・活性化・転換・リピート購入の成長サイクルを効率的に構築。テクノロジーの実装を、実際の業績向上と効率改善の成果へと転換します。",
        "豊富な技術蓄積と業界実践を基盤に、自社開発のコア製品AISalesPro AI営業システムをいち早く実装。AI音声アウトバウンド／オンラインAIカスタマーサービス、意図理解、異議処理、見込み客選別、フルサイクル成約促進を一体化した営業能力により、従来の反復的な手作業を代替し、企業の運営コストを大幅に削減しながら営業転換効率を向上。AIテクノロジーとビジネス成長の深い融合を実現し、「技術のための技術ではなく、企業の成果のために」という核心理念を一貫して貫いています。"
      ]
    },
    credentials: {
      title: "権威ある認証と技術的保障",
      content:
        "国家認定ハイテク企業および上海市専精特新中小企業として、Link2shopsの技術体系と全プラットフォームサービスシステムは、PCI DSS決済カード業界データセキュリティ認証、国家サイバーセキュリティレベル3保護認証など、国内外の権威あるセキュリティ・技術認証を取得。厳格なコンプライアンス基準によりデータセキュリティとビジネス信頼の防衛線を構築し、すべてのインテリジェントサービスと取引プロセスの安全・安定・コンプライアンスを保障します。"
    },
    background: {
      title: "ブランド背景とグローバルサービスネットワーク",
      content:
        "富友グループの戦略的出資を受け、上海に本社を置き、北京、武漢、香港、東京などに支店・拠点を設置。グローバルサービスネットワークは中国、日本、韓国、シンガポール、タイなど多国・多地域をカバー。長年の業界深耕により、約300の著名ブランド、1万店舗以上のオフライン店舗にサービスを提供。飲食・小売、エンターテインメント・旅行、金融特典、生活サービスなど多様なビジネスシーンに対応し、グローバル・多シーン・大規模な実装サービス能力を備えています。"
    },
    ecosystem: {
      title: "全域エコシステムパートナーネットワーク",
      intro:
        "世界トップクラスのビジネスエコシステムリソースと深く連携。WeChat、Alipay、Meituanなど主要トラフィックプラットフォームの公式サービスプロバイダーとして、企業のパブリック・プライベートドメイン流量の効率的な統合を支援。コアエコシステムパートナーは以下の通り：",
      categories: [
        {
          title: "金融機関",
          partners: ["Visa", "中国建設銀行", "中国工商銀行", "中国銀行", "招商銀行"]
        },
        {
          title: "航空会社・通信事業者",
          partners: ["春秋航空", "中国東方航空", "吉祥航空", "中国移動"]
        },
        {
          title: "グローバル旅行プラットフォーム",
          partners: ["Booking", "Agoda", "Ctrip", "Meituan", "Douyin"]
        }
      ]
    },
    aiStrategy: {
      title: "AI戦略的展開と長期的価値",
      content:
        "人工知能をコア戦略として、大規模モデルの商用化、インテリジェントマーケティング、企業効率のデジタル化分野を継続的に深耕し、AI製品ポートフォリオを不断に拡大。今後は企業の全業務プロセスに対応し、AIインテリジェントフォローアップ、全域インテリジェント運営、チーム効率管理、データドリブン成長分析などのAI製品・ソリューションを順次リリース。フロントエンドのインテリジェント集客、ミドルエンドのビジネス転換、バックエンドの効率管理まで、エンドツーエンドでAIテクノロジーにより企業のデジタルアップグレードを支援し、グローバルビジネスパートナーのコスト削減、売上増加、持続的かつ安定した成長を実現し続けます。"
    }
  },
  products: {
    servers: [
      {
        title: "流通サービス",
        subTitle:
          "にワンストップのシステムインテグレーションサービスを提供する",
        desc:
          "Link2shopsは海外の業者にワンストップのシステムインテグレーションサービスを提供し、業者の商品とサービスを中国と海外の一部の航空会社や銀行やＯＴＡ（オンラインの旅行会社）などのチャンネルに配分します。それに、オンライン予約とモバイル決済とカスタマーサポートとマーケティングを含まれるいろいろなのサービスも提供し、業者の売り上げを向上させ、販売の便利性とブランド影響力の拡大も目指しています。"
      },
      {
        title: "マーケティングサービス",
        subTitle:
          "中国のハイエンドの顧客を対象とするマーケティングサービスを業者に提供します。",
        desc:
          "Link2shopsは中国の銀行、航空会社、大企業などのプラットフォームにいるハイエンドの顧客に権益を提供し、顧客タイプとプラットフォームの特徴によってカスタマイズされたマーケティングキャンペーンを業者に提供します。また、業者の情報を関連するプラットフォームで公開し、ハイエンドの顧客の消費を促進、プラットフォームのブランドの影響を借り、業者のブランドの価値を向上させます。"
      },
      {
        title: "ソフトウェアの小売のサービス",
        subTitle: "ソフトウェアの小売のサービスを業者に提供する",
        desc:
          "Link2shopsは業者に以下のシステムソフトウェアサービスを提供する：電子チケットシステム（流通、决済）、予約システム、決済システム（アリペイ、Wechat、アップルペイなど）"
      }
    ]
  },
  company: {
    title: "取引先の会社",
    name: "上海富恵ネットワーク株式会社",
    website: "ホームページ",
    customer: "カスタマーサービス",
    business: "ビジネス協力",
    fax: "ファックス",
    email: "Ｅメール",
    address: "アドレス",
    addressDesc: "上海浦东新区金藏路351号富友科技園6号ビル2階",
    companyType1: "金融機関",
    companyType2: "業者"
  },
  contact: {
    menu1: "連絡先",
    menu2: "ビジネス協力"
  },
  about: {
    desc1:
      "Link2shopsは上海富恵ネットワーク株式会社が中国内外の業者を対象とする設立した総合的なシステムサービスのブランドであり、主旨は業者に流通、予約、プロモーション、支払いなどを含まれた統合的なソリューションを提供します。",
    desc2:
      "上海富恵ネットワーク株式会社は上海富友グループによって全額出資し、設立された子会社です。上海、北京、香港、東京に子会社、支店、事務所を構えています。上海富友グループは中国国内で高い知名度を持ってる金融グループであり、事業の規模が年間8000億人民幣（約1150億米ドル）です。グループは9個完全子会社を持ち、サードパーティ決済ライセンスを含まれた多数な中国人民銀行、中国国家外国為替管理局などの政府部門によって発行された特許経営ライセンスを持ってます。"
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/ja.js